import SearchIcon from '@mui/icons-material/Search'
import {InputAdornment, TextField} from '@mui/material'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../consts'

type EditKpisSearchProps = {
  value: string
  onChange: (value: string) => void
}

export const EditKpisSearch = ({value, onChange}: EditKpisSearchProps) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)

  return (
    <TextField
      fullWidth
      placeholder={t('editKpisModal.searchPlaceholder')}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      size="small"
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon fontSize="small" />
          </InputAdornment>
        )
      }}
      sx={{maxWidth: 300}}
    />
  )
}
